import React, { useState } from 'react'
import styles from './index.scss'
import DpBusinessPopup from '@/libs/components/DpBusinessComponents/DpBusinessPopup'
import DpBusinessCommodity from '@/libs/components/DpBusinessComponents/DpBusinessCommodity'
import DpRichText from '@/libs/components/DpFunctionComponents/DpRichText'
import { RightOutline } from 'antd-mobile-icons'
import DpTracker from '@/libs/components/DpTrackerComponents/DpTracker'
import { TrackView } from '@dragonpass/intl-unified-tracker'

const PopUpDetailModal = (props: any) => {
  const [visible, updateVisible] = useState(false)
  return (
    <>
      <div className={styles['dp-BusinessPopup--header']} style={props?.customStyles}>
        <span
          className={styles['dp-BusinessPopup--header-title']}
          onClick={(event) => {
            event?.stopPropagation()
            updateVisible(!visible)
            if (props?.hasTrackerPermission) {
              window?.dpTracker?.sendClk?.({
                eventData: {
                  module_name: props?.tracker_module_name || '规格弹窗',
                  component_name: `查看${props?.tracker_module_name || '规格说明'}`,
                }
              })
            }
          }}
          style={props?.style}
          aria-label={props?.name || '服务介绍'}
        >
          {props?.name || '服务介绍'} {!props?.hiddenIcon ? <RightOutline /> : undefined}
        </span>
      </div>
      <DpBusinessPopup
        title={
          <>
            <DpBusinessCommodity.Goods
              data={{
                img: props?.data?.skuImage || props?.proDetail?.listViewUrl,
                title: <div style={{
                  marginBottom: 2,
                  fontSize: 15,
                  fontWeight: 500,
                  lineHeight: '26px',
                  textAlign: 'left'
                }}>{props?.proDetail?.proName}</div>,
                tips: props?.title,
              }}
              goodsStyles={{ padding: '16px 16px 10px', background: 'var(--page-bg-color, #f5f6f8)' }}
              imgStyles={{ width: 72, height: 54 }}
            />
          </>
        }
        visible={visible}
        onClose={() => updateVisible(!visible)}
        headerStyle={{ borderBottomWidth: 0,  padding: 0 }}
        titleStyle={{
          color: 'var(--primary-text-color, #202020)',
          textAlign: 'left',
        }}
        popupBodyStyles={{
          ...props?.customStyles,
          background: `var(--page-bg-color, #f5f6f8)`,
        }}
        containerStyles={{
          background: `var(--content-bg-color, #ffffff)`,
          borderRadius: '16px',
          margin: '0 10px 10px',
        }}
        popupProps={{
          getContainer:() => document.body
        }}
      >
        <DpTracker>
          <TrackView
            component="div"
            trackClk={false}
            trackData={{
              module_name: `${props?.tracker_module_name || '规格说明'}弹窗`,
            }}
            trackExp={props?.hasTrackerPermission}
            onClick={(e) => {
              e.stopPropagation()
            }}
          >
            <DpRichText data={props?.data?.specProDetail}/>
          </TrackView>
        </DpTracker>
      </DpBusinessPopup>
    </>
  )
}
export default PopUpDetailModal
